import Execute from "./Execute";

/**
 * execute 指令
 * @param manager 管理
 */
export default function() {
    return new Execute()
}

